import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import DealerVerificationInfo from "./component";
import { openLoginPopup } from "../../au.configuration/actions";
import withLogin from "../with-login";
import { createClassifiedLead } from "../checkout-info/actions";

const mapStateToProps = (
    {
        carDetails: {
            cmsConfig,
            config,
            content,
            metaContent,
            leadAppointment
        },
        user: {
            phoneNumberVerified
        },
        dealer: {
            dealerInfo
        }
    }
) => ({
    cmsConfig,
    config,
    content,
    metaContent,
    phoneNumberVerified,
    leadAppointment,
    dealerInfo
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    openLoginPopupConnect: openLoginPopup,
    createClassifiedLeadConnect: createClassifiedLead
}, dispatch);

export default withLogin(connect(mapStateToProps, mapDispatchToProps)(DealerVerificationInfo));
